exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".nav-link.active a[data-v-0f916a0d]{color:#495057}.nav-tabs .nav-link.disabled[data-v-0f916a0d]{color:rgba(0,0,0,.2);background-color:transparent;border-color:transparent}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0f916a0d","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/course/chapter/ChapterNavigation.vue
// module id = 244
// module chunks = 0